import packageJson from "../../../package.json";
// import { handling500ErrorCode, refr } from "./error-codes";
import notify from "utils/notifications";
import { refreshToken, handling500ErrorCode } from "./error-codes";

export const handleResponse = (response) => {
  const config = response?.config;
  if (config.raw) {
    return response;
  }

  if (response.status === 200 || response.status === 201) {
    const data = response?.data;
    if (!data) {
      throw new Error("No Date Found!");
    }
    return data;
  }
};

export const handleResponseError = async (error) => {
  const originalRequest = error.config;
  if (!originalRequest) {
    notify("error", "Unexpected error occurred. Please try again.");
    return Promise.reject(error);
  }
  const maxRetries = originalRequest.retry || 5;
  const attempt = originalRequest._attempt || 0;
  originalRequest._attempt = attempt;

  if (
    error.response &&
    error.response.status === 404 &&
    error.response.statusText === "Not Found"
  ) {
    notify("error", "404 Not Found!!!", {
      position: "top-right"
    });
  }

  if (
    error.response &&
    error.response.status === 500 &&
    attempt < maxRetries - 1
  ) {
    if (attempt === maxRetries - 2) {
      notify("error", "Internal server error. Please try again later.", {
        position: "top-right"
      });
    }

    return handling500ErrorCode(originalRequest, maxRetries);
  }

  if (
    error.response &&
    error.response.status === 401 &&
    !originalRequest._retry
  ) {
    const authHeader = error.config.headers["Authorization"];
    if (
      !authHeader ||
      authHeader.trim() === "Bearer null" ||
      authHeader.trim() === "Bearer undefined"
    ) {
      notify(
        "error",
        `Error: ${error.response.data?.message || "Something went wrong"}`,
        {
          position: "top-right"
        }
      );
    } else {
      return refreshToken();
    }
  }
  return Promise.reject(error);
};

// (error) => {
//     if (error.response && error.response.status === 401) {
//       if (!isRedirecting) {
//         isRedirecting = true; // Set flag to true to prevent multiple redirects
//         error?.response?.data?.message !== "Session expired" &&
//           notify("error", error?.response?.data?.message);
//         localStorage.removeItem("token");
//         localStorage.removeItem("login-type");
//         localStorage.removeItem("token-data");

//         history.replace({
//           pathname: "/error",
//           state: {
//             message: error?.response?.data?.message || "Session Expired",
//             statusCode: error.response.status,
//             errors: error?.response?.data
//           }
//         });

//         // Optional: Reset the flag after a short delay to allow future redirects
//         setTimeout(() => {
//           isRedirecting = false;
//         }, 1000); // Adjust delay as needed
//       }
//     } else if (error.response && error.response.status === 500) {
//       return Promise.reject(error.response);
//     } else {
//       return Promise.reject(error);
//     }
//   }
